const currencyMapping = {
  currencies_supported: [
    "AED",
    "AUD",
    "BRL",
    "CAD",
    "EUR",
    "GBP",
    "IDR",
    "INR",
    "SGD",
    "THB",
    "USD",
  ],
  currency_mapping: {
    AED: {
      code: "784",
      locale: "ar-DZ",
      symbol: "د.إ",
      name: "Emirati Dirham",
      minor: "fil",
      denomination: 100,
      min_value: 200,
      min_auth_value: 100,
    },
    AUD: {
      code: "036",
      locale: "en-AU",
      symbol: "A$",
      name: "Australian Dollar",
      minor: "cent",
      denomination: 100,
      min_value: 50,
      min_auth_value: 100,
    },
    BRL: {
      code: "986",
      locale: "pt-BR",
      symbol: "R$",
      name: "Brazillian Real",
      minor: "centavo",
      denomination: 100,
      min_value: 50,
      min_auth_value: 100,
    },
    CAD: {
      code: "124",
      locale: "en-CA",
      symbol: "C$",
      name: "Canadian Dollar",
      minor: "cent",
      denomination: 100,
      min_value: 50,
      min_auth_value: 100,
    },
    EUR: {
      code: "978",
      locale: "en-GB",
      symbol: "€",
      name: "Euro",
      minor: "cent",
      denomination: 100,
      min_value: 50,
      min_auth_value: 100,
    },
    GBP: {
      code: "826",
      locale: "en-GB",
      symbol: "£",
      name: "British Pound",
      minor: "pence",
      min_value: 30,
      denomination: 100,
      min_auth_value: 100,
    },
    IDR: {
      code: "360",
      locale: "id-ID",
      symbol: "Rp",
      name: "Indonesian Rupiah",
      minor: "sen",
      denomination: 100,
      min_value: 1000,
      min_auth_value: 100,
    },
    INR: {
      code: "356",
      locale: "en-IN",
      symbol: "₹",
      name: "Indian Rupee",
      minor: "paise",
      denomination: 100,
      min_value: 100,
      min_auth_value: 100,
    },
    SGD: {
      code: "702",
      locale: "en-SG",
      symbol: "S$",
      name: "Singapore Dollar",
      minor: "cent",
      denomination: 100,
      min_value: 50,
      min_auth_value: 100,
    },
    THB: {
      code: "764",
      symbol: "฿",
      locale: "th-TH",
      name: "Thai Baht",
      minor: "satang",
      denomination: 100,
      min_value: 1000,
      min_auth_value: 100,
    },
    USD: {
      code: "840",
      locale: "en-US",
      symbol: "$",
      name: "US Dollar",
      minor: "cent",
      denomination: 100,
      min_value: 50,
      min_auth_value: 100,
    },
  },
};

export default currencyMapping;